export default "__VITE_ASSET__197f49a1__"